import React, { FC } from 'react';
import TextModuleContainer from '../@shared/textModuleContainer';
import { TextModuleProps } from '../@shared/textModuleContainer/types/textModuleContainer.types';

const ThankYou: FC<TextModuleProps> = (props) => {
  return (
    <TextModuleContainer
      iconName="action-checkmark-circle"
      trackAnalyticsEvents={false}
      showGenericPopup={false}
      extraClassName={"thank-you__text-module"}
      {...props}
    />
  );
};

export default ThankYou;